import _ from 'lodash';
import { getProxiedServiceUrl } from '@xengage/gw-portals-url-js';
import { JsonRPCService } from '@xengage/gw-portals-transport-js';
import { DocumentUploadService } from '@xengage/gw-portals-document-js';

export default class PolicyService {
    static policySummaries = {};

    static getAccountPolicyDetailsByDate_ML = (data, authHeader)=> {
        const missingData = [];
        const returnPeriods = [];
        const policySummaryIds = [];

        _.forEach(data, (effectiveDate, policyNumber) => {
            const policySummaryId = policyNumber.toString().concat(',').concat(effectiveDate.year).concat('-').concat(effectiveDate.month).concat('-').concat(effectiveDate.day);
            policySummaryIds.push(policySummaryId);

            const periodSummary = PolicyService.policySummaries[policySummaryId];
            if (!periodSummary) {
                missingData.push({policyNumber, effectiveDate});
            } else {
                returnPeriods.push(periodSummary);
            }
        });
        if (Object.keys(missingData).length) {
            const promise = JsonRPCService.send(getProxiedServiceUrl('policy'), 'getAccountPolicyPeriodDetailsByDate', [missingData], authHeader);
            promise.then((periodSummaryData) => {
                periodSummaryData.forEach((periodData) => {
                    returnPeriods.push(periodData);
                    const policySummaryId = periodData.policyNumber.concat(',').concat(periodData.effective_ML.year).concat('-').concat(periodData.effective_ML.month).concat('-').concat(periodData.effective_ML.day);
                    PolicyService.policySummaries[policySummaryId] = periodData;
                });
                return returnPeriods;
            });
            return promise;
        }

        return new Promise((resolve) => {
            resolve(returnPeriods);
        });
    };

    static policyPeriodSummaries = {};

    static getAccountPolicyPeriodDetailsByDate_ML = (policyNumber, effectiveDate, authHeader) => {
        const policyPeriodSummaryId = policyNumber.concat(',').concat(effectiveDate.year).concat('-').concat(effectiveDate.month).concat('-').concat(effectiveDate.day);
        const periodPeriodSummary = PolicyService.policyPeriodSummaries[policyPeriodSummaryId];
        
        if (!periodPeriodSummary) {
            const promise = JsonRPCService.send(getProxiedServiceUrl('policy'), 'getAccountPolicyDetailsByDate', [policyNumber, effectiveDate], authHeader);
            promise.then((periodSummaryData) => {
                PolicyService.policyPeriodSummaries[policyPeriodSummaryId] = periodSummaryData;
                return periodSummaryData;
            });
            return promise;
        }

        return new Promise((resolve) => {
            resolve(periodPeriodSummary);
        });
    }

    static getAccountPolicySummaries(authHeader = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('policy'), 'getAccountPolicySummaries', [], authHeader);
    }

    static getAccountPolicyDetails(policyNumber, authHeader = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('policy'), 'getAccountPolicyDetails', [policyNumber], authHeader);
    }

    static getAccountPolicySummariesIncludingCancellations(authHeader = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('policy'), 'getAccountPolicySummariesIncludingCancellations', [], authHeader);
    }

    static removeDocument(publicID, authHeader = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('removePolicyDocument'), 'removeDocument', [publicID], authHeader);
    }

    static uploadDocument(document, documentMetadata, authHeader = {}) {
        return DocumentUploadService.send(getProxiedServiceUrl('uploadPolicyDocument'), document, documentMetadata, authHeader);
    }

    static getDocumentUploadToken(additionalHeaders) {
        return JsonRPCService.send(getProxiedServiceUrl('generateUploadToken'), 'generateUploadToken', [], additionalHeaders);
    }

    static getAccountPaymentPolicySummaries(additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('policy'), 'getAccountPaymentPolicySummaries', [], additionalHeaders);
    }

    static retrieveQuoteUrlIfOpenQuotes(additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('policy'), 'retrieveQuoteUrlIfOpenQuotes', [], additionalHeaders);
    }

    static getAccountOpenQuotes(additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('policy'), 'getAccountOpenQuotes', [], additionalHeaders);
    }

    static getAccountPolicyDetailsByDate(policyNumber, effectiveDate, authHeader = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('policy'), 'getAccountPolicyDetailsByDate', [policyNumber, effectiveDate], authHeader);
    }

    static getPolicyDetailsByJobNumber(jobNumber, authHeader = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('policy'), 'getPolicyDetailsByJobNumber', [jobNumber], authHeader);
    }

    static getLatestIDCard(policyNumber, authHeader = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('policy'), 'getLatestIDCard', [policyNumber], authHeader);
    }
    
    static getNewDocumentsCount(isMobileDevice, last3years, authHeader = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('policyDocs'), 'getNewDocumentsCount', [isMobileDevice, last3years], authHeader);
    }

    static setDocumentAsViewed(docId, token, authHeader = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('policyDocs'), 'setDocumentAsViewed', 
            [docId, token], authHeader)
    }

    static getAvailableMailingLocations(accountNumber, policyNumber, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('policy'),
            'getAvailableMailingLocations', [accountNumber, policyNumber], additionalHeaders);
    }
}
